type ObjectArrayEntryType = {
	[key: string]: string | number;
};

/*
 * const objectArray = [{id:23}, {id:25}, {id:0}];
 * const index = getIndexOfObjectArrayEntry(objectArray, 'id', 25);
 * // index is 1
 **/
const indexOfObjectInArray = (
	objectArray: ObjectArrayEntryType[],
	attributeKey: string,
	value: string | number
): number => {
	let out: number = -1;
	objectArray.every((entry: ObjectArrayEntryType, index: number) => {
		if (entry[attributeKey] === value) {
			out = index;
			return false;
		}
		return true;
	});
	return out;
};

export default indexOfObjectInArray;
